import {
  CHANGE_NODEGROUP,
  CHANGE_HADOOP,
  CHANGE_MYSQL,
  CHANGE_VIA,
  CHANGE_DOMAIN_NAME,
  ENABLE_DRUID,
  CHANGE_DRUID,
  ENABLE_GITEA,
  CHANGE_GITEA,
  ENABLE_NEO4J,
  CHANGE_NEO4J,
} from "@/resources-def";

const getAIOpsConfig = (uiFormData) => {
  const component = "aiops";
  return [
    {
      name: component,
      // user-selectable (see useAIOpsConfig.jsx's nodegroup field); read at deploy time by
      // AIOpsHelm.overrideValues(). Create-time only -- AIOps has no Update form.
      nodegroup: uiFormData[`${component}.nodegroup`],
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
      dataDisk: uiFormData[`${component}.dataDisk`],
      variables: uiFormData[`${component}.variables`],
    },
  ];
};

const getGiteaConfig = (uiFormData) => {
  const component = "gitea";
  return [
    {
      name: component,
      // user-selectable (see useGiteaConfig.jsx's nodegroup field); read at deploy time by
      // GiteaHelm.overrideValues() and, on change, applied live by GiteaHelm.update_more()
      nodegroup: uiFormData[`${component}.nodegroup`],
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
      dataDisk: uiFormData[`${component}.dataDisk`],
    },
  ];
};

const getNeo4jConfig = (uiFormData) => {
  const component = "neo4j";
  return [
    {
      name: component,
      // user-selectable (see useNeo4jConfig.jsx's nodegroup field); read at deploy time by
      // Neo4jHelm.overrideValues() and, on change, applied live by Neo4jHelm.update_more()
      nodegroup: uiFormData[`${component}.nodegroup`],
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
      dataDisk: uiFormData[`${component}.dataDisk`],
      heapInitialSize: uiFormData[`${component}.heapInitialSize`],
      heapMaxSize: uiFormData[`${component}.heapMaxSize`],
      pagecacheSize: uiFormData[`${component}.pagecacheSize`],
    },
  ];
};

const getDruidConfig = (uiFormData) => {
  let druid = [];
  const viaComponents = ["druid-zookeeper", "coordinator", "broker", "router", "middleManager", "historical", "druid-all"];
  viaComponents.forEach((component) => {
    var data = {
      name: component,
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
      dataDisk: uiFormData[`${component}.dataDisk`],
    };
    if("druid-all" != component) {
      data["javaOpts"] = uiFormData[`${component}.javaOpts`];
    }
    druid.push(data);
  });
  druid.push({
    name: "env",
    variables: uiFormData['env.variables']
  })
  return druid;
};

const getVIAConfig = (uiFormData) => {
  let via = [];
  const viaComponents = ["via-ds", "via-rs", "via-ps", "via-fs", "via-all"];
  viaComponents.forEach((component) => {
    via.push({
      name: component,
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
      dataDisk: uiFormData[`${component}.dataDisk`],
      javaOpts: uiFormData[`${component}.javaOpts`],
    });
  });
  return via;
};

const getMySQLConfig = (uiFormData) => {
  let mysql = [];
  const mysqlComponents = ["mysql", "mysql-router", "mysql-console", "mysql-master"];
  mysqlComponents.forEach((component, index) => {
    mysql.push({
      name: component,
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
    });
    if (component == "mysql") {
      mysql[index].dataDisk = uiFormData[`${component}.dataDisk`];
      mysql[index].poolSize = uiFormData[`${component}.poolSize`];
    } else if (component === "mysql-console" || component === "mysql-master") {
      mysql[index].dataDisk = uiFormData[`${component}.dataDisk`];
    }
    if (component === "mysql-master") {
      // user-selectable (see useMySQLConfig.js's mysqlMasterColumns()); read at deploy time by
      // MySQLNonHAHelm.overrideValues() and, on change, applied live by
      // MySQLNonHAHelm.update_more(). Not offered for mysql/mysql-router/mysql-console -- see
      // that hook's comment for why.
      mysql[index].nodegroup = uiFormData[`${component}.nodegroup`];
    }
  });
  return mysql;
};

const getHadoopConfig = (uiFormData) => {
  let hadoop = [];

  const hadoopComponents = [
    "zookeeper",
    "hadoop-hdfs-nn",
    "hadoop-hdfs-jn",
    "hadoop-hdfs-dn",
    "spark-master",
    "spark-worker",
  ];
  hadoopComponents.forEach((component, index) => {
    hadoop.push({
      name: component,
      replicas: uiFormData[`${component}.replicas`],
      core: uiFormData[`${component}.core`],
      memory: uiFormData[`${component}.memory`],
    });

    if (component === "zookeeper") {
      hadoop[index].dataDisk = uiFormData[`${component}.dataDisk`];
      hadoop[index].logDisk = uiFormData[`${component}.logDisk`];
      hadoop[index].javaOpts = uiFormData[`${component}.javaOpts`];
    } else if (
      component === "hadoop-hdfs-nn" ||
      component === "hadoop-hdfs-jn" ||
      component === "hadoop-hdfs-dn"
    ) {
      hadoop[index].dataDisk = uiFormData[`${component}.dataDisk`];
      hadoop[index].javaOpts = uiFormData[`${component}.javaOpts`];
    } else if (component === "spark-worker") {
      hadoop[index].dataDisk = uiFormData[`${component}.dataDisk`];
      hadoop[index].workerMem = uiFormData[`${component}.workerMem`];
    }
  });
  return hadoop;
};

export const getNodegroupConfig = (uiFormData, prefix = "") => {
  let nodegroup = [];
  const ngComponents = [
    `${prefix}master`,
    `${prefix}worker`,
    `${prefix}database`,
  ];
  if(uiFormData.enableDruid) {
    ngComponents.push(`${prefix}druid-master`);
    ngComponents.push(`${prefix}druid-worker`);
  }
  ngComponents.forEach((component) => {
    nodegroup.push({
      name: component,
      minSize: uiFormData[`${component}.minSize`],
      maxSize: uiFormData[`${component}.maxSize`],
      desiredSize: uiFormData[`${component}.desiredSize`],
      instanceTypes: uiFormData[`${component}.instanceTypes`],
      disk: uiFormData[`${component}.disk`],
    });
  });
  return nodegroup;
};

const getPoolConfig = (uiFormData) => ({
  hadoop: uiFormData["pool.hadoop"],
  mysql: uiFormData["pool.mysql"],
  size: uiFormData["pool.size"],
});

export const genInstanceProfileForServer = (uiFormData) => {
  let backendValues = {};
  if (uiFormData.type === "silo" || uiFormData.type === "pool-infra") {
    let users = [];
    let addons = [];
    if(uiFormData.users != null) {
      for (var i = 0; i < uiFormData.users.length; i++) {
        users.push({'name': uiFormData.users[i]});
      }
    }
    if(uiFormData.additionAddons != null) {
      for (var i = 0; i < uiFormData.additionAddons.length; i++) {
        addons.push({'id': uiFormData.additionAddons[i]});
      }
    }
    backendValues = {
      name: uiFormData.name,
      type: uiFormData.type,
      version: uiFormData.version,
      platform: uiFormData.platform,
      zone: uiFormData.zone,
      enableDiagnosticsUpload: uiFormData.enableDiagnosticsUpload,
      enableSelfMonitoring: uiFormData.enableSelfMonitoring,
      users: users,
      startAllModules: uiFormData.startAllModules,
      enableBiggerPoolSize: uiFormData.enableBiggerPoolSize,
      enableDruid: uiFormData.enableDruid ? true : false,
      enableGitea: uiFormData.enableGitea ? true : false,
      enableNeo4j: uiFormData.enableNeo4j ? true : false,
      enableAPIGatewayMSK: uiFormData.enableAPIGatewayMSK ? true : false,
      template: uiFormData.template,
      additionAddons: addons,
      profile: {},
    };
    if (uiFormData.domain) {
      backendValues.domain = uiFormData.domain;
    }
  }
  if (uiFormData.type === "hadoop" || uiFormData.type === "mysql") {
    backendValues = {
      eks: uiFormData.eks,
      type: uiFormData.type,
      nodegroup: uiFormData.nodegroup,
      name: uiFormData.name,
      capacity: uiFormData.capacity,
      profile: {},
    };
  }
  if (uiFormData.type === "nodegroup") {
    backendValues = {
      id: uiFormData.id,
      type: uiFormData.nodegroupType,
      eks: uiFormData.eks,
      region: uiFormData.region,
      zone: uiFormData.zone,
      autoscaled: String(uiFormData.autoscaled),
      profile: {},
    };
  }

  if (uiFormData.type === "silo") {
    const myNodegroupConfig = getNodegroupConfig(uiFormData);
    backendValues.profile.nodegroups = myNodegroupConfig;

    const myHadoopConfig = getHadoopConfig(uiFormData);
    backendValues.profile.hadoop = myHadoopConfig;

    const mysqlConfig = getMySQLConfig(uiFormData);
    backendValues.profile.mysql = mysqlConfig;

    const druidConfig = getDruidConfig(uiFormData);
    backendValues.profile.druid = druidConfig;

    const giteaConfig = getGiteaConfig(uiFormData);
    backendValues.profile.gitea = giteaConfig;

    const neo4jConfig = getNeo4jConfig(uiFormData);
    backendValues.profile.neo4j = neo4jConfig;

    const viaConfig = getVIAConfig(uiFormData);
    backendValues.profile.via = viaConfig;

    const aiOpsConfig = getAIOpsConfig(uiFormData);
    backendValues.profile.aiops = aiOpsConfig;
  } else if (uiFormData.type === "pool-infra") {
    const pool = getPoolConfig(uiFormData);
    backendValues.profile.pool = pool;

    const viaConfig = getVIAConfig(uiFormData);
    backendValues.profile.via = viaConfig;

    const druidConfig = getDruidConfig(uiFormData);
    backendValues.profile.druid = druidConfig;

    const aiOpsConfig = getAIOpsConfig(uiFormData);
    backendValues.profile.aiops = aiOpsConfig;
  } else if (uiFormData.type === "hadoop") {
    const myHadoopConfig = getHadoopConfig(uiFormData);
    backendValues.profile.hadoop = myHadoopConfig;
  } else if (uiFormData.type === "mysql") {
    const mysqlConfig = getMySQLConfig(uiFormData);
    backendValues.profile.mysql = mysqlConfig;
  } else if (uiFormData.type === "nodegroup") {
    const myNodegroupConfig = getNodegroupConfig(uiFormData);
    backendValues.profile.nodegroups = myNodegroupConfig;
  }

  return backendValues;
};

export const genUpdateProfileForServer = (uiFormData, action) => {
  const backendValues = {
    profile: {},
  };
  if (action === CHANGE_NODEGROUP) {
    const myNodegroupConfig = getNodegroupConfig(uiFormData);
    backendValues.profile.nodegroups = myNodegroupConfig;
  } else if (action === CHANGE_HADOOP) {
    const myHadoopConfig = getHadoopConfig(uiFormData);
    backendValues.profile.hadoop = myHadoopConfig;
  } else if (action === CHANGE_MYSQL) {
    const mysqlConfig = getMySQLConfig(uiFormData);
    backendValues.profile.mysql = mysqlConfig;
  } else if (action === CHANGE_VIA) {
    const viaConfig = getVIAConfig(uiFormData);
    backendValues.profile.via = viaConfig;
  } else if(action === ENABLE_DRUID) {
    uiFormData.enableDruid = true;
    const myNodegroupConfig = getNodegroupConfig(uiFormData);
    backendValues.profile.nodegroups = myNodegroupConfig.filter((item) => item.name.indexOf("druid") != -1);
    const myDruidCOnfig = getDruidConfig(uiFormData);
    backendValues.profile.druid = myDruidCOnfig;
    backendValues.profile.enableDruid = true;
  } else if(action === CHANGE_DRUID) {
    const myDruidCOnfig = getDruidConfig(uiFormData);
    backendValues.profile.druid = myDruidCOnfig;
  } else if(action === ENABLE_GITEA) {
    uiFormData.enableGitea = true;
    // no profile.nodegroups here: gitea rides the existing master nodegroup
    const myGiteaConfig = getGiteaConfig(uiFormData);
    backendValues.profile.gitea = myGiteaConfig;
    backendValues.profile.enableGitea = true;
  } else if(action === CHANGE_GITEA) {
    const myGiteaConfig = getGiteaConfig(uiFormData);
    backendValues.profile.gitea = myGiteaConfig;
  } else if(action === ENABLE_NEO4J) {
    uiFormData.enableNeo4j = true;
    // no profile.nodegroups here: the "database" nodegroup this rides on already exists
    // (desiredSize 0 by default) and SetupNeo4jStep.ensure_database_nodegroup() resizes it
    // to 1 on the provisioner side when needed
    const myNeo4jConfig = getNeo4jConfig(uiFormData);
    backendValues.profile.neo4j = myNeo4jConfig;
    backendValues.profile.enableNeo4j = true;
  } else if(action === CHANGE_NEO4J) {
    const myNeo4jConfig = getNeo4jConfig(uiFormData);
    backendValues.profile.neo4j = myNeo4jConfig;
  }
  return backendValues;
};
